import { render } from "./svg-wave-animated.vue?vue&type=template&id=3335605f&scoped=true"
const script = {}

import "./svg-wave-animated.vue?vue&type=style&index=0&id=3335605f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3335605f"]])

export default __exports__